import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {getApiIsbnUrl, getBulkCreateIsbnsUrl, getSetUnusedIsbnUrl, getUnusedIsbnUrl} from '../app.urls';
import {IsbnModel, IsbnResult} from '../models/isbn.model';
import {Observable} from 'rxjs/Observable';
import {map} from 'rxjs/operators';

@Injectable()
export class IsbnService {
    constructor(private http: HttpClient) {
    }

    createIsbns(isbns:IsbnModel[]) {
        return this.http
            .post(getApiIsbnUrl(), isbns);
    }

    bulkCreateIsbns(isbns: IsbnModel[]): Observable<IsbnResult[]> {
        return this.http
            .post(getBulkCreateIsbnsUrl(), isbns)
            .pipe(map((res: any) => res as IsbnResult[]))
    }

    getUnusedisbns() {
        return this.http
            .get(getUnusedIsbnUrl());
    }
    setIsbnUnused(id:number) {
        return this.http
            .get(getSetUnusedIsbnUrl()+'/'+id);
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/isbn.service.ts